import React, { useState } from "react";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import { Form, Button } from "react-bootstrap";
import { useContext } from "react";
import { ApiContext } from "../DistContext/DisContext";
import toastr from "toastr";

const Offers = () => {
  const [offerName, setOfferName] = useState("");
  const [offerType, setOfferType] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [purchase, setPurchase] = useState("");
  const [freeProductCount, setFreeProductCount] = useState("");
  const [productImage, setProductImage] = useState(null);
  const { products } = useContext(ApiContext);
  const disId = localStorage.getItem("id");
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create a FormData object to send the file
    const formData = new FormData();
    formData.append("name", offerName);
    formData.append("image", productImage);
    formData.append("type", offerType);
    formData.append("product_id", selectedProduct);
    formData.append("distributor_id", disId);
    formData.append("product_name", "");
    formData.append("activation_value", purchase);

    try {
      const response = await fetch("http://api.meddaily.in/addoffer", {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        toastr.success("Offer created successfully")
        // console.log("Offer created successfully",response);
        setOfferName("");
        setOfferType("");
        setSelectedProduct("");
        setPurchase("");
        setFreeProductCount("");
        setProductImage(null);
      } else {
        console.error("Failed to create offer");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
// console.log(offerName,offerType,productImage,purchase,freeProductCount,selectedProduct)
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />
          <div className="layout-page">
            <Navbar />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card mb-12">
                    <div className="card-header d-flex justify-content-between align-items-center"></div>

                    <div className="card-body">
                      <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                          <div className="card mb-3">
                            <div className="card-body">
                              <div>
                                <h3 className="card-title ">Create Offer</h3>
                              </div>
                              <Form onSubmit={handleSubmit}>
                                <div className="row text-start">
                                  <div className="col-md-6">
                                    <Form.Group controlId="offerName">
                                      <Form.Label>Offer Name:</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter offer name"
                                        value={offerName}
                                        onChange={(e) =>
                                          setOfferName(e.target.value)
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="col-md-6">
                                    <Form.Group controlId="offerType">
                                      <Form.Label>Offer Type:</Form.Label>
                                      <Form.Select
                                        value={offerType}
                                        onChange={(e) =>
                                          setOfferType(e.target.value)
                                        }
                                      >
                                        <option value="">
                                          Select offer type
                                        </option>
                                        <option value="discount">
                                          Discount
                                        </option>
                                        <option value="bonus quantity">
                                          Bonus Quantity
                                        </option>
                                      </Form.Select>
                                    </Form.Group>
                                  </div>
                                  <div className="col-md-6">
                                    <Form.Group controlId="selectedProduct">
                                      <Form.Label>Select a Product:</Form.Label>
                                      <Form.Select
                                        value={selectedProduct}
                                        onChange={(e) =>
                                          setSelectedProduct(e.target.value)
                                        }
                                      >
                                        <option value="">
                                          Select a product
                                        </option>
                                        {products && products.map((product) => (
                                          <option
                                            key={product.id}
                                            value={product.name}
                                          >
                                            {product.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Form.Group>
                                  </div>
                                  <div className="col-md-6">
                                    <Form.Group controlId="purchase">
                                      <Form.Label>Purchase:</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter purchase"
                                        value={purchase}
                                        onChange={(e) =>
                                          setPurchase(e.target.value)
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="col-md-6">
                                    <Form.Group controlId="freeProductCount">
                                      <Form.Label>
                                        Free Product Count:
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter free product count"
                                        value={freeProductCount}
                                        onChange={(e) =>
                                          setFreeProductCount(e.target.value)
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="col-md-6">
                                    <Form.Group controlId="productImage">
                                      <Form.Label>
                                        Upload Product Image:
                                      </Form.Label>
                                      <Form.Control
                                        type="file"
                                        accept=".jpg,.png,.jpeg"
                                        onChange={(e) =>
                                          setProductImage(e.target.files[0])
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className="mt-5 d-flex justify-content-center">
                                    <button type="submit"
                                      className="btn btn-primary"
                                      style={{
                                        backgroundColor: "#6eafab",
                                        border: "1px solid #6eafab",
                                      }}
                                    >
                                      Create
                                    </button>
                                  </div>
                                </div>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Offers;
